import { tokens } from '@domain-group/fe-brary';
import { outlineButtonStyles } from '../utils';
var secondary = tokens.colors.secondary;
export default outlineButtonStyles(secondary);